export const buttonTextBreakpoint = '@media (min-width: 400px)';
export const partialHorizontalBreakpoint = '@media (min-width: 619px)';
export const fullHorizontalBreakpoint = '@media (min-width: 1140px)';
export const iconsBreakpoint = '@media (min-width: 454px)';
export const paddingBreakpoint = '@media (min-width: 370px)';
